import { createI18n } from 'vue-i18n';
import en from '../locales/en.json';
import bn from '../locales/bn.json';

const messages = {
    en,
    bn,
};

const i18n = createI18n({
    locale: localStorage.getItem('locale') || 'en', // Default to saved locale or English
    fallbackLocale: 'en',
    messages,
});
// const i18n = createI18n({
//   legacy: true, 
//   globalInjection: true,
//   locale: localStorage.getItem('locale') || 'en',
//   fallbackLocale: 'en',
//   messages,
// });


export default i18n;
